<template>
  <div class="jumbotron-container mb-5 bg-gradient">
      <div class="jumbotron jumbotron-fluid jumbotron-select py-4">
        <div class="container">
          <div class="row justify-content-between mb-5">
                <div class="col-md-6 col-sm-12"><a class="btn btn-white text-primary"  @click="gotostartpage">
                  <svg class="icon">
                    <use xlink:href="/assets/img/icon-sprite.svg#global.previous" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                  </svg>{{__('lang.btn.reset.gotostartpage')}}</a>
                </div>

<!-- 

                <div class="col-6 col-md-3">
                 <productsearch parentID="list"></productsearch>	
                </div> -->
          </div>
        
        <span v-show="$parent.search_flag=='op'|| ($parent.search_flag == 'showresult' && op.airflow>0)">
          
        <!--   <operatingpointoverview :showopdata="op_data" :showselcat="selected_categories" :showselcatdesc="descselectedCategories"></operatingpointoverview>   -->
          <operatingpointoverview></operatingpointoverview>  
         </span>           
        </div>
      </div>
  </div>

    
</template>

<script>
    //import productsearch  from './ProductSearch' 
    import operatingpointoverview  from './OperatingPointOverview'
    
    export default {
         components: {
            operatingpointoverview,
            /*productsearch,*/
        },
                
        computed: {
            op: {
              get() {
                return this.$store.state.operatingpoint.op;
              },
              set(value) {
                this.$store.commit('operatingpoint/updateop', value);
              }
            },
        },
        data() {
          return {
           /*   op_data: {
                 
                  airflow: '',
                  pressure: '',
                  airflowunits: 1,
                  airflowunits_options: [{}],
                  pressureunits: 5,
                  pressureunits_options: [{}],
                  pressuretype: 'stat',
                  pressuretype_options: [{}],
                  airflow_deviation: [],
                  pressure_deviation: [],
                  units: [],
                  maxdba: ''
            }, 
            selected_categories: [],
            descselectedCategories:[]
            */
          }
        },
        methods: {
         /*  clearSession() {
            this.$root.$emit("clearSession",{
              from:"Productlistjumbotron"
            })

          } */
          gotostartpage() {
            this.$root.$emit("gotostartpage",{
              from:"Productlistjumbotron"
            })

          },
         /*  reloadData() {
          // Implement your data reloading logic here
            console.log('i am in opoverview reloaddata');
            
            this.op_data = Object.assign({},this.$store.state.operatingpoint.op)
            this.selected_categories = [...this.$store.state.operatingpoint.selectedCategories];
            this.descselectedCategories = [...this.$store.state.operatingpoint.descselectedCategories]
            this.$nextTick(() => {
              // Watcher should trigger now
            

            });
          },  */

        },
        created() {
         /*    console.log('i am in opoverview created this.$store.state.operatingpoint.op');
            console.log(this.$store.state.operatingpoint.op);
            // Attach event listener to the 'beforeunload' event
            this.op_data = this.$store.state.operatingpoint.op
            this.selected_categories =  this.$store.state.operatingpoint.selectedCategories
            this.descselectedCategories = this.$store.state.operatingpoint.descselectedCategories;
            this.$nextTick(() => {
              // Watcher should trigger now
              

            }); 
            console.log('i am in opoverview created op_data');
            console.log(this.op_data);

                     
            
            window.addEventListener('beforeunload', this.reloadData); */
            console.log('i am in opoverview created',this.op);

        },
        mounted() {
        

        },
        watch: {
          op: {
            immediate: true,
            deep: true,
            handler(newVal) {
              console.log('op watcher jumbotron', newVal)
              this.$nextTick(() => {
                this.op = newVal; // Manually updating the value
                //this.$store.commit('operatingpoint/updateop', newVal);
              });
            }
          },
        },
      /*   beforeDestroy() {
          // Don't forget to remove the event listener when the component is destroyed
          window.removeEventListener('beforeunload', this.reloadData);
        } */
    }
</script>
